import { useQuery } from '@tanstack/react-query';
import { api } from '../../api/http';

export type Message = { kind: 'ok' | 'error'; text: string } | null;

/** The school's currency, for showing and entering fees. */
export function useCurrency(schoolId: string): string {
  const school = useQuery({
    queryKey: ['schools', schoolId],
    queryFn: () => api<{ currencyCode: string }>(`/schools/${schoolId}`),
  });
  return school.data?.currencyCode ?? 'USD';
}

export interface Vehicle {
  id: string;
  registrationNumber: string;
  vehicleType: string;
  capacity: number;
  status: 'active' | 'maintenance' | 'retired';
  insuranceExpiry: string | null;
  fitnessExpiry: string | null;
}
export interface Driver {
  id: string;
  fullName: string;
  phone: string;
  licenceNumber: string;
  licenceExpiry: string;
  status: 'active' | 'inactive';
}
export interface Route {
  id: string;
  name: string;
  status: 'active' | 'inactive';
  vehicleRegistration: string | null;
  driverName: string | null;
  capacity: number | null;
  seated: number;
  stopCount: number;
}
export interface Stop {
  id: string;
  name: string;
  position: number;
  pickupTime: string | null;
  dropTime: string | null;
  monthlyFeeMinor: number;
  seated: number;
}
export interface Person {
  id: string;
  firstName: string;
  lastName: string;
  admissionNumber?: string;
}
